<template>
  <div class="guide">
    <v-container>
      <h4>はじめに</h4>
      <p>
        {{
          AppName
        }}は行動を記録して改善に役立てるためのタイムトラッキングツールです。
      </p>
      <p>
        例えば、メールへの返信があなたの集中を阻害しているかもしれません。<br />
        行動を記録して客観的に改善方法を探ってみましょう。
      </p>

      <h4>行動を記録する</h4>
      <p>
        Home画面に並んでいるTaskを選択すると記録が開始されます。<br />
        もう一度同じTaskを選択すると記録が終了します。
      </p>
      <p>
        Taskが選択されている状態でも他のTaskを選択できます。<br />
        前のTaskの記録が終了され、新しいTaskの記録が開始されます。
      </p>
      <p>
        Taskを選択する前にCategoryを選択しておくと、後からどのCategoryでどのようなTaskを行ったのかがわかりやすくなります。<br />
        TaskやCategoryはSetting画面でカスタマイズできます。
      </p>
      <h4>行動を振り返る</h4>
      <p>
        Analytics画面では1日の行動を振り返ることができます。<br />
        最大で過去7日まで振り返ることができます。<br />
        7日経過したデータは自動的に削除されます。
      </p>
      <v-divider></v-divider>
      <p class="text-decoration-underline mt-4">
        <label class="font-weight-bold">Point</label>
        毎日欠かさず記録を取る必要はありません。
      </p>
      <p>
        典型的な１日を記録し、行動を振り返り、改善方法を見つけましょう。<br />
        改善を試みた１日を記録してより良い１日になったか振り返ってみてください。<br />
        行動習慣が変わったときには、また{{ AppName }}を使ってみてください。
      </p>
      <p class="text-decoration-underline">
        <label class="font-weight-bold">Point</label>
        正確に記録を取る必要はありません。
      </p>
      <p>
        {{ AppName }}は行動を改善するためのヒントを探すためのツールです。<br />
        正確に記録することはそれほど重要なことではありません。<br />
        大体の傾向がつかめる程度に記録することを心がけてみてください。
      </p>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      AppName: process.env.VUE_APP_NAME,
    };
  },
};
</script>